<template>
  <div>
    <vs-prompt
      :title="isNew ? 'Add allergy' : 'Update allergy'"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      :accept-text="isNew ? 'Add' : 'Update'"
      :is-valid="validForm"
      class=""
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input v-model="name" />
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      existingId: null,
      name: "",
      prompt: false,
    };
  },
  computed: {
    ...mapGetters({}),
    isNew() {
      return !this.existingId;
    },
    validForm() {
      return this.name && this.name.length > 0;
    },
  },
  methods: {
    show(withStorage) {
      this.name = "";
      //   this.taxRate = 0.25;
      this.existingId = null;

      if (withStorage) {
        this.existingId = withStorage.allergyId.id;
        this.name = withStorage.name;
        // this.taxRate = withStorage.taxRate;
      }
      this.prompt = true;
    },
    async accept() {
      const dto = {
        name: this.name,
      };

      if (this.isNew) {
        dto.id = this.uuidv4();
        this.$store.commit("pos/countrySettings/createAllergy", dto);
      } else {
        dto.id = this.existingId;
        this.$store.commit("pos/countrySettings/updateAllergy", dto);
      }
    },
    uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      );
    },
    close() {},
  },
};
</script>

<style lang="scss" scoped>
</style>
